import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 成人视频指南',
    description: '成人视频指南致力于为成年用户提供日本成人视频相关的合法合规指导与正版资源推荐。',
    url: 'https://example.com/about',
    mainEntity: {
      '@type': 'Organization',
      name: '成人视频指南',
      description: '专业的日本成人视频资讯平台，提供正版平台推荐、法律合规解读、安全观看指南和行业深度分析。',
      foundingDate: '2024',
    },
  };

  const statsData = [
    { value: '5000+', label: '中文字幕作品收录' },
    { value: '12+', label: '深度原创文章' },
    { value: '5', label: '内容分类覆盖' },
    { value: '100%', label: '正版倡导率' },
  ];

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <div className="min-h-screen pt-16">
        {/* Header */}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
            <div className="mb-4">
              <Breadcrumb items={[{ label: '关于我们' }]} />
            </div>
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
              了解我们的使命、价值观和团队背景
            </p>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    成人视频指南成立于2024年，是国内首批专注于日本成人视频领域资讯与指导的专业平台。
                    我们致力于为成年用户提供全面、准确、合法的日本成人视频相关信息。
                  </p>
                  <p>
                    我们深知成人内容消费需要理性和负责任的引导。因此，平台的所有内容都围绕合法合规、
                    安全防护和理性消费三个核心理念展开，帮助用户在享受成人娱乐的同时，保护好自己。
                  </p>
                  <p>
                    我们的编辑团队由资深行业观察者、法律专业人士和网络安全专家组成，确保每一篇文章
                    都具备专业性和可信度。我们坚持原创内容，不接受未经核实的第三方投稿。
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20team%20working%20on%20content%20creation%2C%20warm%20ambient%20lighting%2C%20wooden%20desks%20with%20laptops%2C%20Japanese%20aesthetic%20inspired%20workspace%2C%20professional%20editorial%20atmosphere%2C%20clean%20and%20sophisticated&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                  alt="品牌介绍"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {statsData.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-bold font-heading text-primary-600 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-8 text-center">
              我们的信誉
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-900">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold font-heading text-foreground-950 mb-2">内容审核标准</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  所有内容经过多轮审核，确保信息准确、来源可靠、观点中立。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600">
                  <i className="ri-user-heart-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold font-heading text-foreground-950 mb-2">用户至上</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  以用户隐私和安全为首要考虑，绝不收集不必要的个人信息。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-900">
                  <i className="ri-article-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold font-heading text-foreground-950 mb-2">原创承诺</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  坚持原创内容生产，不抄袭、不洗稿，维护知识产权。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
              <form
                id="contact-form"
                data-readdy-form="true"
                action="https://readdy.ai/api/form/d9srk3d8o1vn02ekul6g"
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="space-y-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      姓名
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-300/60 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-300/60 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    主题
                  </label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-300/60 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="咨询主题"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    留言
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={5}
                    maxLength={500}
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-300/60 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容（不超过500字）"
                  ></textarea>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="spam-protection-field"
                />

                <button
                  type="submit"
                  className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}